import { IsOptional, ValidateNested } from 'class-validator';
import { IsValidNumber, IsValidString } from '@cnx-saas/common';
import {
  ArticleInput,
  ArticlePackagingInput,
  PackageDimensions,
  Packaging,
  PackagingParentFull,
  PackagingParentRef,
} from '../types'; // NOTE: decorators can be part of ArticleInput instead

// NOTE: decorators can be part of ArticleInput instead
// NOTE: we can make cnx-validators like @IsExternalReference() and @IsName() and @IsWeight()

class ArticleUnitInputValidationSchema implements Packaging {
  @IsValidString()
  packagingCode: string;

  packagingDescription?: string;

  @IsValidNumber({ integer: true, min: 1 })
  articlesPerPackage: number;

  // TODO: default to 0 for imported data without stack size
  // TODO: open question for schott: is this optional?
  @IsValidNumber({ integer: true, min: 0, max: 9999 })
  maxStackSize: number;

  @ValidateNested()
  dimensions: PackageDimensions;

  @IsOptional()
  @ValidateNested()
  parent?: PackagingParentFull;
}

export class PackagingParentInputValidationSchema
  implements PackagingParentRef
{
  @IsValidString()
  packagingCode: string;

  @IsValidNumber({ integer: true, min: 1, max: 9999 })
  quantityChildrenPerParent: number;
}

export class PackageDimensionsValidationSchema implements PackageDimensions {
  @IsValidNumber({ min: 0.001, max: 9999 })
  weight: number;

  @IsValidNumber({ min: 1, max: 99999 })
  height: number;

  @IsValidNumber({ min: 1, max: 99999 })
  width: number;

  @IsValidNumber({ min: 1, max: 99999 })
  length: number;
}

export class ArticleInputValidationSchema implements ArticleInput {
  // @IsExternalReference()
  @IsValidString({ optional: true })
  externalReference?: string;

  // @IsName()
  @IsValidString({ minLength: 3, maxLength: 255 })
  name: string;

  // @IsWeight()
  @IsValidNumber({ min: 0.001, max: 9999 })
  weightInKgPerUnit: number;

  packagingOptions: ArticlePackagingInput[];
}
